// extracted by mini-css-extract-plugin
export default {"ThankYou":"thanks_ThankYou__R1BmN","ThankYouContent":"thanks_ThankYouContent__tiz09","links":"thanks_links__imQSf","linkInicio":"thanks_linkInicio__mqyvy"};